export { ModalComponentV1 } from "./ModalComponentV1";
